import styled, { css } from "styled-components";
import { theme } from "../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";

export const Valuation = styled.div`
    margin-bottom: ${theme.space[5]}px;
    text-align: center;
`;

export const ValuationGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 0;
    row-gap: ${theme.space[3]}px;
    margin-bottom: ${theme.space[5]}px;
`;

export const ValuationItem = styled.div<{ fullWidth?: boolean }>`
    ${({ fullWidth }) =>
        fullWidth &&
        css`
            grid-column: 1/-1;
        `}
`;

export const ValuationLabel = styled.div<{ light?: boolean }>`
    margin-bottom: ${theme.space[1]}px;
    font-family: ${theme.fonts.regular};
    font-size: 1.6rem;
    line-height: 2.4rem;
    text-align: center;
    color: ${({ light }) => (light ? theme.colors.grey3 : theme.colors.primaryBlack)};
`;

export const ValuationValue = styled.div<{ light?: boolean }>`
    font-family: ${theme.fonts.regular};
    font-size: 2.8rem;
    line-height: 3.2rem;
    text-align: center;
    color: ${({ light }) => (light ? theme.colors.grey3 : theme.colors.primaryBlack)};
`;

export const ValuationLoading = styled.div`
    position: relative;
    min-height: 100px;
    margin: ${theme.space[4]}px ${theme.space[2]}px;
    padding-top: ${theme.space[6]}px;
`;

export const LoaderText = styled.div`
    margin-top: ${theme.space[1]}px;
    text-align: center;
`;
